import { Flex, FlexProps } from '@chakra-ui/core'
import React from 'react'
import { Check } from 'lucide-react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface IStatusCircleProps extends FlexProps {
  color: string
  showIcon?: boolean
  disableAbsolutePosition?: boolean // Если true, убирает абсолютное позиционирование
}

export const StatusCircle: React.FC<IStatusCircleProps> = ({
  color,
  showIcon = false,
  disableAbsolutePosition = false,
  ...props
}) => {
  const isRtl = useSelector(isRtlSelector)

  return (
    <Flex
      w="10px"
      h="10px"
      bg={color}
      borderRadius="full"
      alignItems="center"
      justifyContent="center"
      pos={disableAbsolutePosition ? 'relative' : 'absolute'}
      top={disableAbsolutePosition ? 'unset' : '5px'}
      left={disableAbsolutePosition ? 'unset' : isRtl ? 'unset' : '5px'}
      right={disableAbsolutePosition ? 'unset' : isRtl ? '5px' : 'unset'}
      {...props}
    >
      {showIcon && <Check color="white" size={16} />}
    </Flex>
  )
}
